// GENERATED by scripts/build-icons.mjs from icons/pause.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Pause = createIcon('pause', [
  ['rect', { x: "14", y: "3", width: "5", height: "18", rx: "1" }],
  ['rect', { x: "5", y: "3", width: "5", height: "18", rx: "1" }],
])
